/**
 * Current language only. Static translations are in client locale JSON files (no API).
 */
import { changeLanguage as i18nChangeLanguage } from '../../i18n/config';
import languageConfig from '../../config/languageConfig';

const DEFAULT_LANG = languageConfig.defaultLanguage;

const initialState = {
  currentLanguage:
    typeof localStorage !== 'undefined' ? localStorage.getItem('preferredLanguage') || DEFAULT_LANG : DEFAULT_LANG,
};

export default function translationReducer(state = initialState, action) {
  switch (action.type) {
    case 'translation/SET_LANGUAGE':
      return { ...state, currentLanguage: action.payload };
    default:
      return state;
  }
}

export function setCurrentLanguage(lang) {
  return { type: 'translation/SET_LANGUAGE', payload: lang };
}

export function loadAndSetLanguage(lang) {
  return (dispatch) => {
    const valid = languageConfig.getLanguageCodes().includes(lang) ? lang : DEFAULT_LANG;
    i18nChangeLanguage(valid);
    dispatch(setCurrentLanguage(valid));
  };
}
